const onArrowLeft =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'ArrowLeft') {
      handler(e, ...args);
    }
  };

export default onArrowLeft;
